import { Card } from 'antd';

import './StyledCard.scss';

const StyledCard = ({
  children,
  extra,
  title,
  id,
}: {
  title?: JSX.Element | string;
  children: JSX.Element;
  extra?: JSX.Element;
  id: string;
}) => {
  return (
    <Card id={`${id}_card`} size="small" title={title} extra={extra} bordered={false}>
      {children}
    </Card>
  );
};

export default StyledCard;
